export default "/images/SamirRegaya.jpg?a75793094119a3f3d3fca0f69f27e1dd";